export { ValuePipe } from '@app/modules/shared/pipes/value.pipe';
export { DateFormatPipe } from '@app/modules/shared/pipes/date-format.pipe';
export { MBitesPipe } from '@app/modules/shared/pipes/m-bites.pipe';
export { MonthYearFormatPipe } from '@app/modules/shared/pipes/month-year-format.pipe';
export { DurationPipe } from '@app/modules/shared/pipes/duration.pipe';
export { FormatAgoPipe } from '@app/modules/shared/pipes/format-ago.pipe';
export { BigNumberPipe } from '@app/modules/shared/pipes/big-number.pipe';
